import axios from 'axios';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import NewFilter from './NewFilter';

const Demo = () => {
  const server_url = process.env.REACT_APP_API_URI;
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [products, setProducts] = useState([]);
  const [ratingso, setRatingso] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [filteredResults, setFilteredResults] = useState([]);
  const [sortOrder, setSortOrder] = useState('ascending');
  const [activeKeys, setActiveKeys] = useState([]);

  const handleActiveKeysChange = (keys) => {
    console.log('Received Active Keys in Parent:', keys);
    setActiveKeys(keys); // now you have access to latest active keys here
  };

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `${server_url}/context/get-all-category`,
        );
        setCategories(response.data.data || []);
      } catch (error) {
        console.error('Error fetching categories:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchCategories();
  }, []);

  useEffect(() => {
    if (selectedCategory) {
      const fetchCategoryData = async () => {
        try {
          const entertainmentResponse = await axios.post(
            `${server_url}/entertainment/get-all-ratings-for-user`,
            { catId: selectedCategory._id },
          );

          if (entertainmentResponse.status === 200) {
            const data = entertainmentResponse.data;
            setProducts(data.products || []);
            setRatingso(data.ratings || []);
            setQuestions(data.questions || []);
          }
        } catch (error) {
          console.error('Error fetching data:', error);
        }
      };
      fetchCategoryData();
    }
  }, [selectedCategory]);

  const handleCategoryChange = async (e) => {
    const selected = categories.find(
      (cat) => cat.id === parseInt(e.target.value),
    );
    setSelectedCategory(selected || null);
    setProducts([]);
    setFilteredProducts([]);
    setShowFilters(false); // Reset filters when category changes

    if (selected?.title === 'Movie') navigate('/advance-search/oldmovies');
    else if (selected?.title === 'Television')
      navigate('/advance-search/oldtv');
  };
  const handleSortOrderChange = (order, questionId) => {
    console.log('Sort Order:', order);
    console.log('Question ID:', questionId);
    setSortOrder(order);
    // You can now use questionId to filter or process the data further, if needed
  };

  const handleFilteredResults = (results) => {
    setFilteredResults(results);

    const filtered = results
      .map((id) => products.find((product) => product.contentId === id))
      .filter(Boolean);

    setFilteredProducts(filtered);
  };

  const displayProducts =
    filteredResults.length > 0 ? filteredProducts : products;

  return (
    <div className="max-w-screen-xl mx-auto mt-4">
      <div className="flex flex-col md:flex-row">
        {/* Left Sidebar */}
        <div className="bg-gray-900 p-3 mb-4 lg:py-4 lg:px-2 mt-4 w-full md:w-1/4 rounded-lg h-fit overflow-y-auto">
          <div className="flex py-2 px-6 flex-wrap mt-2">
            <h3 className="text-lg font-semibold text-secondary">Category</h3>
            {loading ? (
              <div className="flex justify-center items-center">
                <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-blue-500"></div>
              </div>
            ) : (
              <select
                value={selectedCategory ? selectedCategory.id : ''}
                onChange={handleCategoryChange}
                className="w-full p-2 border bg-gray-100 rounded-lg"
              >
                <option value="">Choose a category</option>
                {categories.map((cat) => (
                  <option key={cat._id} value={cat.id}>
                    {cat.title}
                  </option>
                ))}
              </select>
            )}
          </div>
          <div className="px-3">
            {selectedCategory && (
              <NewFilter
                ratingso={ratingso}
                questions={questions}
                onFilteredResults={handleFilteredResults}
                sortOrder={sortOrder}
                onActiveKeysChange={handleActiveKeysChange}
                onSortOrderChange={handleSortOrderChange}
              />
            )}
          </div>
        </div>

        {/* Right Content */}
        <div className="px-5 my-4 flex-1">
          {/* Sort Buttons */}
          {activeKeys.length > 0 && (
            <div className="bg-[#2d2d2d] p-2 mb-5 rounded-xl">
              <div className="flex space-x-4 flex-wrap">
                {/* Display Sorting UI */}
                {questions.map((question) => (
                  <div key={question.id}>
                    {/* Buttons to change sort order for each question */}
                    <button
                      onClick={() => handleSortOrderChange('desc', question.id)}
                      className={`px-6 py-2 font-semibold rounded-full shadow-lg transition transform hover:scale-105 focus:outline-none ${
                        sortOrder === 'desc'
                          ? 'bg-secondary text-primary'
                          : 'bg-primary text-secondary'
                      }`}
                    >
                      Top to Bottom
                    </button>

                    <button
                      onClick={() => handleSortOrderChange('asc', question.id)}
                      className={`px-6 py-2 font-semibold rounded-full shadow-lg transition transform hover:scale-105 focus:outline-none ${
                        sortOrder === 'asc'
                          ? 'bg-secondary text-primary'
                          : 'bg-primary text-secondary'
                      }`}
                    >
                      Bottom to Top
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}

          <div className="grid place-items-center lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-2 gap-6">
            {displayProducts.length === 0 ? (
              <p className="text-center col-span-full text-gray-500">
                No products available.
              </p>
            ) : (
              displayProducts.map((product) => (
                <div
                  key={product.contentId}
                  className="bg-white p-3 rounded-xl shadow-md hover:shadow-xl transition-transform transform hover:scale-105 cursor-pointer w-full max-w-xs h-40 flex flex-col justify-between"
                  onClick={() =>
                    navigate(
                      `/rate/${selectedCategory?.title.toLowerCase()}/${product.contentId}`,
                    )
                  }
                >
                  <h2>{product.contentId}</h2>
                  <h3 className="text-lg font-bold text-gray-800 mb-2">
                    {product.contentName}
                  </h3>
                  <p className="text-gray-600 text-sm mb-4 line-clamp-3 flex-grow">
                    {product.contentDescription}
                  </p>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Demo;
